var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 2.33398H5.83398C3.90099 2.33398 2.33398 3.90099 2.33398 5.83398V9.33398C2.33398 11.267 3.90099 12.834 5.83398 12.834H9.33398C11.267 12.834 12.834 11.267 12.834 9.33398V5.83398C12.834 3.90099 11.267 2.33398 9.33398 2.33398Z",
    fill: "#717579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 2.33398H18.668C16.735 2.33398 15.168 3.90099 15.168 5.83398V9.33398C15.168 11.267 16.735 12.834 18.668 12.834H22.168C24.101 12.834 25.668 11.267 25.668 9.33398V5.83398C25.668 3.90099 24.101 2.33398 22.168 2.33398Z",
    fill: "#717579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 15.168H5.83398C3.90099 15.168 2.33398 16.735 2.33398 18.668V22.168C2.33398 24.101 3.90099 25.668 5.83398 25.668H9.33398C11.267 25.668 12.834 24.101 12.834 22.168V18.668C12.834 16.735 11.267 15.168 9.33398 15.168Z",
    fill: "#717579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 15.168H18.668C16.735 15.168 15.168 16.735 15.168 18.668V22.168C15.168 24.101 16.735 25.668 18.668 25.668H22.168C24.101 25.668 25.668 24.101 25.668 22.168V18.668C25.668 16.735 24.101 15.168 22.168 15.168Z",
    fill: "#717579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderHome);
export default __webpack_public_path__ + "static/media/header-home.6c1f2667372d0e331664b690d6198987.svg";
export { ForwardRef as ReactComponent };